import Model from './BaseModel';

export default class TrackBetType extends Model {
	resourceName() {
		return 'track_bet_types';
	}

	fields() {
		return ['product', 'bet_type', 'race_type'];
	}

	// override the base update for our request specific URL
	update(trackId, raceTypeId, data) {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/tracks/${trackId}/race_types/${raceTypeId}/bet_types`,
			method: 'POST',
			data
		});
	}
}
